import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

const MailboxProBox = ({
 selectedNumber,
 selectNumber
}: {
 selectedNumber: number;
 selectNumber: (probox: number) => void;
}): ReactElement => {
 const mailboxSize = [5, 10, 15];

 return (
  <Stack spacing={2}>
   <Stack>
    <Typography variant="subtitle2">
     <FormattedMessage id="container.maildomains.mailProDescription" />
    </Typography>
    <Typography variant="subtitle2">
     <FormattedMessage id="container.maildomains.mailProList" values={{ br: <br /> }} />
    </Typography>
    <Typography variant="subtitle2">
     <FormattedMessage id="container.maildomains.mailProMailbox" />
    </Typography>
   </Stack>
   <Stack direction="row" flexWrap="wrap">
    {mailboxSize.map((element, index) => {
     return selectedNumber === element ? (
      <Paper
       key={`type-${index}`}
       sx={{
        backgroundColor: "#c8e6c9",
        px: 4,
        py: 2,
        minWidth: 200,
        m: 1
       }}
       onClick={() => selectNumber(element)}>
       <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography fontWeight="bold" textTransform="uppercase">
         {`${element} Mailbox PRO`}
        </Typography>
       </Stack>
      </Paper>
     ) : (
      <Tooltip
       key={`type-paper-${index}`}
       title={<FormattedMessage id="server.add.selectTypeTitle" />}>
       <Paper
        key={`type-${index}`}
        sx={{
         px: 4,
         py: 2,
         cursor: "pointer",
         minWidth: 200,
         m: 1
        }}
        onClick={() => selectNumber(element)}>
        <Stack direction="row" alignItems="center" justifyContent="center">
         <Typography fontWeight="bold" textTransform="uppercase">
          {`${element} Mailbox PRO`}
         </Typography>
        </Stack>
       </Paper>
      </Tooltip>
     );
    })}
   </Stack>
   <Stack>
    <Typography variant="subtitle2">
     <FormattedMessage id="container.maildomains.mailboxProNumber" />
    </Typography>
    <TextField
     fullWidth={true}
     type="number"
     InputLabelProps={{ shrink: true }}
     sx={{ my: 2 }}
     autoComplete="off"
     value={selectedNumber}
     onChange={({ currentTarget }) => selectNumber(Number(currentTarget.value))}
    />
   </Stack>
  </Stack>
 );
};

export default MailboxProBox;
